import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";
import {
  invokeApi,
  notification_fields_shape,
  nullable_field,
  parse,
} from "../_helpers";

const update_self_schema = z.object({
  first_name: nullable_field(z.string()),
  last_name: nullable_field(z.string()),
  phone: nullable_field(z.string()),
  avatar_url: nullable_field(z.url("Avatar URL is not a valid URL")).optional(),
  ...notification_fields_shape,
});

export const update_self: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(update_self_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, "api/users/self", {
    method: "PUT",
    body: parsed.data,
  });
  if (!result.ok) return result;
  invalidate("users");
  toast({ variant: "success", text: "Profile updated!" });
  removeQueryParams(["modal", "id"]);
  return result;
};
